/**
 * @file step
 * @author zhaomiaoyuan
 */
import React, {useState, useEffect} from 'react';
import {withRouter} from 'react-router';
import PropTypes from 'prop-types';
// import Modal from 'antd/lib/modal';
import UploadProof from '../../components/UploadProof/index.tsx';
import InputFormItem from '../../components/InputFormItem/index.tsx';
import SendCode from '../../components/SendCode/index.tsx';
// import AgreeProtocol from '../../components/AgreeProtocol/index.tsx';
import {
    certTip
} from '../../components/UploadProof/uploadTip.tsx';
import {recordProxy, bCat_2055_request} from '../../util';
// import {appealTypeEventTracking} from './conf';
import geren1 from '../../asset/img/appeal/geren_1.jpg';
import geren2 from '../../asset/img/appeal/geren_2.png';
import geren3 from '../../asset/img/appeal/geren_3.jpg';
import videoDemo from '../../asset/img/appeal/video-demo.gif';
import {rePhone} from './conf';

// import {Button, message} from 'antd';
import './appeal.less';

const PersonModal = (props) => {
    const {
        updateAppeal,
        appealData,
        fetchSendCode,
    } = props;
    const [telType, setTelType] = useState('');

    useEffect(() => {
        setTelType(rePhone.test(appealData.phone) ? 'phone' : 'tel');
    }, [appealData.phone]);

    function onSendCodeChange ({captchaTip}) {
        const recordType = window.location.pathname.indexOf('/occupy') > -1
            ? 'report-number_captcha' : 'report-mark_captcha';
        recordProxy(
            recordType,
            'click',
            captchaTip === '获取验证码' ? '获取验证码' : '重新发送'
        );
    }

    return (
        <div className="person-modal">
            {telType === 'tel' && <UploadProof
                proofType="video"
                title="证明材料"
                isMsgRequired={true}
                type="cert"
                maxImgLength={10}
                data={appealData}
                updateData={updateAppeal}
                tips={certTip()}
                demoImgs={[geren1, geren2, videoDemo]}
            />}
            {telType === 'tel' && <InputFormItem
                title="联系邮箱"
                isMsgRequired={true}
                placeholder="请输入正确的邮箱地址用来接收审核结果"
                type="email"
                data={appealData}
                updateData={updateAppeal}
                style={{width: '424px'}}
                demoImgs={[]}
            />}
            {telType === 'tel' && <SendCode
                title="邮箱验证码"
                isMsgRequired={true}
                type="emailCode"
                data={appealData}
                updateData={updateAppeal}
                sendData={appealData.email}
                fetchSendCode={fetchSendCode}
                onSendCodeChange={onSendCodeChange}/>}
            {telType === 'phone' && <SendCode
                title="手机验证码"
                isMsgRequired={true}
                type="phoneCode"
                data={appealData}
                updateData={updateAppeal}
                sendData={appealData.phone}
                fetchSendCode={fetchSendCode}
                onSendCodeChange={onSendCodeChange}/>}
            {/* <AgreeProtocol
                type="isRead"
                data={appealData}
                updateData={updateAppeal} />
            <div className="btn-content">
                {!appealData.hasSearchUrl && <Button
                    className="btn-step2"
                    onClick={preClick}>上一步</Button>
                }
                <Button
                    className="btn-step2-primary"
                    type="primary"
                    disabled={!appealData.isRead}
                    onClick={nextClick}>提交</Button>
            </div> */}
        </div>
    );
};

PersonModal.propTypes = {
    updateAppeal: PropTypes.func,
    appealData: PropTypes.object,
    fetchSendCode: PropTypes.func
};

export default withRouter(PersonModal);
